<template>
  <div>
    <v-navigation-drawer 
      app
      temporary
      v-model="drawer"
      >
      <v-list dense>
        <v-list-tile to="/main">
          <v-list-tile-action>
            <v-icon>home</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>Main</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile to="/user">
          <v-list-tile-action>
            <v-icon>people</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>Users</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile to="/log">
          <v-list-tile-action>
            <v-icon>table_chart</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>User Logs</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile to="/about">
          <v-list-tile-action>
            <v-icon>info</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>About</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile to="/cardinfo">
          <v-list-tile-action>
            <v-icon>perm_contact_calendar</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>Card Information</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-list-tile to="/changelog">
          <v-list-tile-action>
            <v-icon>track_changes</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>Changelog</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-divider></v-divider>
        <v-list-tile to="/emergency">
          <v-list-tile-action>
            <v-icon>warning</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>Emergency</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-divider></v-divider>
        <v-list-tile @click="logout">
          <v-list-tile-action>
            <v-icon>exit_to_app</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>Logout</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-navigation-drawer>
    <v-toolbar flat dark class="blue">
      <v-toolbar-side-icon @click.stop="drawer = !drawer"></v-toolbar-side-icon>
      <!-- <v-spacer></v-spacer> -->
      <v-toolbar-title>
        <img src="@/assets/onsight_logo.png" style="height: 40px; padding-top: 10px"/>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <span>{{name}}</span>
    </v-toolbar>
  </div>
</template>

<script>
import firebase from 'firebase'
export default {
  data () {
    return {
      drawer: false,
      name: '',
      isLoggedIn: false,
      currentUser: false,
      currentUserAdmin: false
    }
  },
  created() {
    if(firebase.auth().currentUser){
      this.name = firebase.auth().currentUser.email
    }
  },
  methods: {
    logout() {
      firebase.auth().signOut().then(() => {
        this.$router.push('/');
      });
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/NavBar.vue